import * as React from "react";
import DetailPage from "../../../components/common/detailPage/detailPage";
import { SimpleBreadcrumbs } from "../../../components/navigation/simpleBreadcrumbs";
import { Link, Typography } from "@mui/material";
import { useParams, Link as RouterLink } from "react-router-dom";
import StandardLayout from "../../../layouts/standard";
import PageLoader from "../../../components/common/pageLoader";
import { useGetEmailTemplateByIdQuery } from "../../../services/cclTokenedEmailTemplateApi";
import { EmailMessageTemplate } from "../../../services/types/emailTemplateTypes";
import EmailTemplateGeneral from "./general/emailTemplateGeneral";

export type EmailTemplateDetailProps = {
    id: string;
};

const EmailTemplateDetail: React.FC = (props) => {
    const params = useParams<EmailTemplateDetailProps>();
    const id = params.id !== undefined ? params.id : "";

    const { data, isLoading } = useGetEmailTemplateByIdQuery(id);

    const emptyData = {} as EmailMessageTemplate;

    const tablist: [string, number, React.ReactNode][] = [
        ["Details", 0, <EmailTemplateGeneral loading={isLoading} data={data ? data : emptyData} />],
    ];

    const breadcrumbs = (
        <SimpleBreadcrumbs>
            <Typography variant="h6" color="text.primary">
                <Link key="findResourceLink" component={RouterLink} to="/emails/templates">
                    Email Templates
                </Link>
            </Typography>
            <Typography variant="h6" color="text.primary">
                {data ? data.templateName : "Loading"}
            </Typography>
        </SimpleBreadcrumbs>
    );

    if (isLoading) {
        return (
            <StandardLayout breadcrumbs={breadcrumbs}>
                <PageLoader msg={""} />
            </StandardLayout>
        );
    }

    return (
        <DetailPage
            breadcrumbs={breadcrumbs}
            descriptor={"resources"}
            tablist={tablist}
        ></DetailPage>
    );
};

export default EmailTemplateDetail;
